import { observable, action } from 'mobx'

export const handleProgress = ({ id, progress }) => {
    mediaProgress.set(id, {
        id,
        progress,
    })
}

const mediaProgress = observable.map({})

export default mediaProgress
